<template>
  <el-dialog width="80%" :title="title + '详情页'" :visible.sync="showDet" :before-close="close">
    <hr style="border-top: 1px solid #f8f9fe" />
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="优惠券信息" name="first">
        <hr style="border-top: 1px solid #f8f9fe" />
        <div>
          <p class="tou">优惠券数量</p>
          <el-table
            class="tab"
            :data="tableDataCount"
            border
            style="width: 70%"
            :header-cell-style="{ background: '#F8F9FE ', color: '#666666' }"
          >
            <el-table-column prop="createCount" label="创建数量" />
            <el-table-column prop="takeCount" label="领取数量" />
            <el-table-column prop="writeOffCount" label="核销数量" />
            <el-table-column prop="expirationCount" label="失效数量" />
            <el-table-column prop="surplusCount" label="剩余数量" />
          </el-table>
        </div>
        <div>
          <p class="tou">优惠券操作</p>
          <el-table
            class="tab"
            :data="tableDatacaozuo"
            border
            style="width: 70%"
            :header-cell-style="{ background: '#F8F9FE ', color: '#666666' }"
          >
            <el-table-column prop="ableTime" label="时间" />
            <el-table-column prop="ableOperate" label="操作">
              <template slot-scope="scope">
                <div v-if="scope.row.ableOperate == 0">停用</div>
                <div v-if="scope.row.ableOperate == 1">启用</div>
              </template>
            </el-table-column>
            <el-table-column prop="ableOperatorName" label="操作人" />
            <el-table-column prop="ableReason" label="原因备注" />
          </el-table>
        </div>
        <div>
          <p class="tou">绑定的商品</p>
          <el-form :inline="true" :model="queryMenu" class="queryMenu">
            <el-form-item label="商品名称">
              <el-input v-model="queryMenu.goods_name"></el-input>
            </el-form-item>
            <el-form-item label="分类名称">
              <el-input v-model="queryMenu.standard_name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleButton(3)">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="tableDataBdgoods"
            :header-cell-style="{ background: '#F8F9FE ', color: '#666666' }"
          >
            <el-table-column prop="goods_id" label="商品ID" />
            <el-table-column prop="shop_name" label="店铺名称" />
            <el-table-column label="商品图片">
              <template slot-scope="scope">
                <img class="imge" :src="scope.row.image_main" alt />
              </template>
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" />
            <el-table-column label="商品规格">多规格</el-table-column>
            <el-table-column prop="standard_name" label="商品分类" />
            <el-table-column prop="price_sell" label="销售价" />
          </el-table>
          <!-- 分页 -->
          <pagination
            v-if="this.dets.couponType == 10"
            :total="total"
            :pageNum="queryMenu.page"
            :pageSize="queryMenu.page_size"
            @pageChange="pageChange"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="优惠券列表" name="second">
        <hr style="border-top: 1px solid #f8f9fe" />
        <el-form :inline="true" :model="queryMenu1" class="demo-form-inline" ref="queryMenu1">
          <el-form-item label="券状态：" prop="isActivation">
            <el-select v-model="queryMenu1.isActivation" placeholder="请选择券状态">
              <el-option
                v-for="item in GLOBALState.TicketStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="券编码：" prop="serialNo">
            <el-input v-model="queryMenu1.serialNo" placeholder="请输入券编码"></el-input>
          </el-form-item>
          <el-form-item label="券兑换码：" prop="activationCode">
            <el-input v-model="queryMenu1.activationCode" placeholder="请输入券兑换码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleButton(2)">重置</el-button>
            <el-button type="primary" @click="handleButton(1)">查询</el-button>
            <el-button type="warning" @click="dc()">导出列表</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableDatagoodslist"
          :header-cell-style="{ background: '#F8F9FE ', color: '#666666' }"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              <span>{{ (queryMenu1.page - 1) * queryMenu1.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="couponType" label="券类型" />
          <el-table-column prop="serialNo" label="券编码" width="200" />
          <el-table-column prop="activationCode" label="券兑换码" />
          <el-table-column prop="status" label="券状态" />
          <el-table-column label="领取人ID" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.userId != 0">{{ scope.row.userId | isNull}}</div>
              <div v-if="scope.row.userId == 0">--</div>
            </template>
          </el-table-column>
          <el-table-column label="领取人昵称" align="center">
            <template slot-scope="scope">{{scope.row.nickName | isNull}}</template>
          </el-table-column>
          <el-table-column label="领取时间" align="center">
            <template slot-scope="scope">{{scope.row.activationTime | isNull}}</template>
          </el-table-column>
          <el-table-column label="核销主/子单号" align="center" width="120">
            <template slot-scope="scope">{{scope.row.orderNo | isNull}}</template>
          </el-table-column>
          <el-table-column label="核销时间" align="center">
            <template slot-scope="scope">{{scope.row.orderTime | isNull}}</template>
          </el-table-column>
          <el-table-column label="失效时间" align="center">
            <template slot-scope="scope">{{scope.row.expirationTime | isNull}}</template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination
          v-if="tableDatagoodslist.length>0"
          :total="total1"
          :pageNum="queryMenu1.page"
          :pageSize="queryMenu1.pageSize"
          @pageChange="pageChange1"
        />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import pagination from "@/components/pagination/index.vue";
import { couponFindCouponCount, merchantCouponsInfoList, couponStatusLogFindAbleInfo, couponChildAll, dcExportCouponChild, couponsgoodsList } from "@/api/couponManagement/couponSetting";
export default {
  props: ["show", "dets", "title"],
  components: {
    pagination,
  },
  data() {
    return {
      showDet: false,
      activeName: "first",
      tableDatabaozj: [],
      tableDataCount: [],
      tableDatazuhe: [],
      tableDatacaozuo: [],
      tableDataBdgoods: [],
      tableDatagoodslist: [],
      total: 0,
      total1: 0,
      queryMenu: {
        goods_name: "",
        standard_name: "",
        coupon_id: "",
        coupons_id: "",
        type: 2,
        page_size: 10,
        page: 1,
      },
      queryMenu1: {
        isActivation: "",
        couponId: "",
        serialNo: "",
        pageSize: 10,
        page: 1,
        activationCode: "",
      },
    };
  },
  watch: {
    show() {
      Object.assign(this.$data, this.$options.data()); //重置data
      this.showDet = this.show;
    },
    dets(row) {
      console.log(row.couponType, "===========");
      if (row.couponType == 10) {
        this.postcouponsgoodsList(this.dets);
      } else {
        this.postmerchantCouponsInfoList(row);
      }
      this.postcouponFindCouponCount(row);
      this.postcouponStatusLogFindAbleInfo(row);
      this.postcouponChildAll();
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleButton(val) {
      switch (val) {
        case 1:
          this.postcouponChildAll();
          break;
        case 2:
          this.queryMenu1.isActivation = "";
          this.queryMenu1.serialNo = "";
          this.queryMenu1.pageSize = 10;
          this.queryMenu1.page = 1;
          this.queryMenu1.activationCode = "";
          this.postcouponChildAll();
          break;
        case 3:
          if (this.dets.couponType == 10) {
            this.postcouponsgoodsList(this.dets);
          } else {
            this.postmerchantCouponsInfoList(this.dets);
          }
          break;
        default:
          break;
      }
    },
    pageChange(page) {
      this.queryMenu.page_size = page._pageSize;
      this.queryMenu.page = page._currentPage;
      if (this.dets.couponType == 10) {
        this.postcouponsgoodsList(this.dets);
      } else {
        this.postmerchantCouponsInfoList(this.dets);
      }
    },
    pageChange1(page) {
      this.queryMenu1.pageSize = page._pageSize;
      this.queryMenu1.page = page._currentPage;
      this.postcouponChildAll();
    },
    // 优惠券数量
    postcouponFindCouponCount(row) {
      couponFindCouponCount(row.id).then((res) => {
        this.tableDataCount = res.result;
      });
    },
    // 优惠券操作
    postcouponStatusLogFindAbleInfo(row) {
      couponStatusLogFindAbleInfo(row.id).then((res) => {
        this.tableDatacaozuo = res.result;
      });
    },
    // 绑定的商品
    postmerchantCouponsInfoList(row) {
      this.queryMenu.coupon_id = row.id;
      let data = this.queryMenu;
      merchantCouponsInfoList(data).then((res) => {
        // this.total = parseInt(res.result.total);
        this.tableDataBdgoods = res.data;
      });
    },
    postcouponsgoodsList(row) {
      this.queryMenu.coupons_id = row.id;
      let data = this.queryMenu;
      couponsgoodsList(data).then((res) => {
        this.total = parseInt(res.data.count);
        this.tableDataBdgoods = res.data.goods_list;
      });
    },
    // 商品列表
    postcouponChildAll() {
      this.queryMenu1.couponId = this.dets.id;
      // this.queryMenu1.activationCode = this.dets.batchNo;
      let data = this.queryMenu1;
      couponChildAll(data).then((res) => {
        this.total1 = parseInt(res.result.total);
        this.tableDatagoodslist = res.result.records;
      });
    },
    // 导出
    dc() {
      this.queryMenu1.couponId = this.dets.id;
      // this.queryMenu1.activationCode = this.dets.batchNo;
      let data = this.queryMenu1;
      dcExportCouponChild(data).then((res) => {
        const blob = res;
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          const a = document.createElement("a");
          a.download = `优惠券列表.xlsx`;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      });
    },
  },
};
</script>

<style scoped>
.tou {
  text-align: left;
  margin: 10px;
  font-size: 20px;
  margin-left: 97px;
}
.tab {
  margin-left: 97px;
}
.queryMenu {
  text-align: center;
}
.imge {
  width: 60px;
  height: 60px;
}
.el-dialog__body {
  padding-top: 0;
}
</style>

